import { render, staticRenderFns } from "./ContactLayout.vue?vue&type=template&id=5895ebf2&scoped=true"
import script from "./ContactLayout.vue?vue&type=script&lang=js"
export * from "./ContactLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5895ebf2",
  null
  
)

export default component.exports